import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#FE5000" d="M13 7h-3V0H6v7H3v1l5 5 5-5zM14 14H2v2h12z" />
  </svg>
);
export default SvgDownloadIcon;
